import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
  value: PropTypes.string.isRequired,
  hasDisabledStyle: PropTypes.bool,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isUnavailable: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'long'])
};
function SizeTile(_ref) {
  var hasDisabledStyle = _ref.hasDisabledStyle,
    id = _ref.id,
    isChecked = _ref.isChecked,
    isDisabled = _ref.isDisabled,
    isUnavailable = _ref.isUnavailable,
    label = _ref.label,
    name = _ref.name,
    onChange = _ref.onChange,
    size = _ref.size,
    type = _ref.type,
    value = _ref.value;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sitg-input-inner-wrapper",
    "data-state": hasDisabledStyle ? 'disabled' : null,
    "data-size": size,
    "data-testid": "sitg-input-inner-wrapper",
    "data-variant": isUnavailable ? 'unavailable' : null
  }, /*#__PURE__*/React__default.createElement("input", {
    checked: isChecked,
    className: "sitg-input",
    disabled: isDisabled,
    id: id,
    name: name,
    onChange: onChange,
    type: type,
    value: value
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "sitg-label-outer",
    "data-testid": "sitg-label-outer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sitg-label-wrapper",
    "data-testid": "sitg-label-wrapper"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "sitg-label",
    "data-testid": "sitg-label",
    htmlFor: id
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "sitg-label-text"
  }, label)))));
}
SizeTile.propTypes = propTypes;

export { SizeTile as default };
//# sourceMappingURL=SizeTile.js.map
